var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685.000000, -1324.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "key"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.25,1325.6875 C693.454048,1325.6875 691.1875,1327.95405 691.1875,1330.75 L691.1875,1330.75371 C691.1875,1331.16738 691.284798,1331.82443 691.404652,1332.22035 L686.6875,1336.9375 L686.6875,1340.3125 L690.0625,1340.3125 L690.0625,1338.625 L691.75,1338.625 L691.75,1336.9375 L692.875,1336.9375 L694.36351,1335.44902 C694.946541,1335.68331 695.583164,1335.8125 696.25,1335.8125 C699.045952,1335.8125 701.3125,1333.54595 701.3125,1330.75 C701.3125,1327.95405 699.045952,1325.6875 696.25,1325.6875 Z M696.25,1324 C699.978176,1324 703,1327.0222 703,1330.75 C703,1334.47818 699.977798,1337.5 696.25,1337.5 C695.774017,1337.5 695.304523,1337.4509 694.845467,1337.3535 L693.4375,1338.76562 L693.4375,1339.46875 C693.4375,1339.93474 693.059742,1340.3125 692.59375,1340.3125 L691.75,1340.3125 L691.75,1341.15625 C691.75,1341.62224 691.372242,1342 690.90625,1342 L685.84375,1342 C685.377758,1342 685,1341.62224 685,1341.15625 L685,1336.588 C685,1336.39508 685.110722,1336.12781 685.247124,1335.99137 L689.56324,1331.67525 C689.521149,1331.36956 689.5,1331.0605 689.5,1330.75 C689.5,1327.02182 692.522202,1324 696.25,1324 Z M696.25,1329.0625 C696.25,1328.13052 697.005516,1327.375 697.9375,1327.375 C698.869484,1327.375 699.625,1328.13052 699.625,1329.0625 C699.625,1329.99448 698.869484,1330.75 697.9375,1330.75 C697.005516,1330.75 696.25,1329.99448 696.25,1329.0625 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1b2e5740.svg";
export { ForwardRef as ReactComponent };